export default "__VITE_ASSET__b62f6190__"